export default __webpack_public_path__ + "static/media/el_cartel.7010af2c.jpg";